import React, { useContext, useReducer } from 'react';
import CircularProgress from '@mui/material/CircularProgress';

// import {useUser} from './auth/context/user-context'
//import {FullPageSpinner} from './auth/components/lib'

import { initialState, userReducer, AUTH, LOG_STATE } from 'auth/userReducer.js';

//import "./App.css"

import { ThemeProvider } from 'contexts/themeContext';
import { AuthProvider } from 'auth/AuthProvider';
import { AuthContext } from 'contexts/authContext';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { CenteredCircularProgress } from 'components/utils/CenteredCircularProgress';

const loadAuthenticatedApp = () => import('AuthenticatedApp');
const AuthenticatedApp = React.lazy(loadAuthenticatedApp);
const UnauthenticatedApp = React.lazy(() => import('auth/UnauthenticatedApp'));
const queryClient = new QueryClient();

//import AuthenticatedApp from 'AuthenticatedApp'
//import UnauthenticatedApp from 'auth/UnauthenticatedApp'

/**
 * Корневой компонент приложения — точка входа в UI.
 * @returns {JSX.Element} Корневой UI-контейнер приложения.
 */
const App = () => {
  console.log('APP');
  // const [state, dispatch] = useReducer(userReducer, initialState);
  // const {state} = useContext(UserContext);
  return (
    // <UserContext.Provider value={{ dispatch, state }}>
    <BrowserRouter
      future={{
            v7_relativeSplatPath: true,
            v7_startTransition: true,
      }}
    >
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <ThemeProvider>
            <React.Suspense fallback={<CenteredCircularProgress color="secondary" />}>
              <AppContent />
            </React.Suspense>
          </ThemeProvider>
        </AuthProvider>
      </QueryClientProvider>
    </BrowserRouter>
    // </UserContext.Provider>
  );
};

function AppContent() {
  const { state } = React.useContext(AuthContext);
  
  // return state.status === LOG_STATE.SETTLED ? <AuthenticatedApp /> : <UnauthenticatedApp />;
  switch(state.status) {
    case LOG_STATE.PENDING:
      return <CenteredCircularProgress />;
    case LOG_STATE.SETTLED:
      return <AuthenticatedApp />;
    case LOG_STATE.REJECTED:
    case LOG_STATE.UNLOGGED:
    default:
      return <UnauthenticatedApp />;
  }
}

export default App;
